import { render, staticRenderFns } from "./BranchCatalogSync.vue?vue&type=template&id=56802f85"
import script from "./BranchCatalogSync.vue?vue&type=script&lang=js"
export * from "./BranchCatalogSync.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports